export const boardMedalSettingsTour = {
  key: "boardMedalSettings",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-medal-toggle"]',
      content: t("Tour_BoardMedalSettings_Toggle"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-medal-schedule"]',
      content: t("Tour_BoardMedalSettings_Schedule"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-medal-ai"]',
      content: t("Tour_BoardMedalSettings_AI"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-medal-thresholds"]',
      content: t("Tour_BoardMedalSettings_Thresholds"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-medal-toggles"]',
      content: t("Tour_BoardMedalSettings_Toggles"),
      placement: "top",
    },
  ],
};
